import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import type { BookPageTranslations } from "@/data/book-page-i18n";

type Copy = BookPageTranslations["bestRateGuarantee"];

type BestRateGuaranteePillProps = {
  copy: Copy;
  /** Localized path to the Best Rate Guarantee page, e.g. `/best-rate-guarantee` or `/de/best-rate-guarantee`. */
  href: string;
  className?: string;
};

/** Taj-style pill: cream background, gold headline + check; entire pill links to the BRG page. */
export function BestRateGuaranteePill({ copy, href, className }: BestRateGuaranteePillProps) {
  return (
    <a
      href={href}
      className={cn(
        "inline-flex max-w-full cursor-pointer flex-col items-center rounded-full bg-[#f5f1e8] px-7 py-2 text-center font-lato no-underline transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#a68945] focus-visible:ring-offset-2 sm:px-9 sm:py-2.5",
        "book:flex book:w-full book:max-w-full",
        className,
      )}
    >
      <div className="flex items-center justify-center gap-1.5 text-sm font-medium leading-none text-[#a68945]">
        <span
          className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full border border-[#a68945]"
          aria-hidden
        >
          <Check className="h-2.5 w-2.5" strokeWidth={2.5} />
        </span>
        <span className="leading-tight">{copy.headline}</span>
      </div>
      <p className="mt-1 max-book:max-w-[19rem] max-book:sm:max-w-[22rem] text-[11px] font-normal leading-tight text-[#333333] sm:text-xs book:max-w-none">
        {copy.subline}
        <span className="book:hidden">
          {" "}
          <span className="underline underline-offset-[3px]">{copy.learnMore}</span>
        </span>
      </p>
    </a>
  );
}
